/**
 * Gesvalt Formularios - Dynamic Fields Handler
 * Maneja la lógica de campos dinámicos basados en otros campos
 */

class GesvaltDynamicFields {
    constructor() {
        // Obtener traducciones
        const i18n = window.GesvaltFormulariosConf?.i18n || {};
        
        this.fieldDependencies = {
            'destino': {
                dependsOn: 'tipo_operacion',
                options: {
                    // Compra de un inmueble (717600000) u Otros (717600002)
                    '': [
                        { value: '717600002', text: i18n.buy_to_use || 'Comprar para usarlo' },
                        { value: '717600003', text: i18n.buy_to_rent || 'Comprar para alquilarlo' },
                        { value: '717600004', text: i18n.other_type || 'Otro tipo' }
                    ],
                    '717600000': [
                        { value: '717600002', text: i18n.buy_to_use || 'Comprar para usarlo' },
                        { value: '717600003', text: i18n.buy_to_rent || 'Comprar para alquilarlo' },
                        { value: '717600004', text: i18n.other_type || 'Otro tipo' }
                    ],
                    '717600002': [
                        { value: '717600002', text: i18n.buy_to_use || 'Comprar para usarlo' },
                        { value: '717600003', text: i18n.buy_to_rent || 'Comprar para alquilarlo' },
                        { value: '717600004', text: i18n.other_type || 'Otro tipo' }
                    ],
                    // Venta de un inmueble (717600001)
                    '717600001': [
                        { value: '717600000', text: i18n.currently_use || 'Actualmente lo uso yo' },
                        { value: '717600001', text: i18n.currently_rented || 'Actualmente está alquilado' }
                    ]
                }
            }
        };
        
        this.init();
    }

    init() {
        this.bindDynamicFields();
    }

    bindDynamicFields() {
        // Buscar todos los formularios de Gesvalt
        const forms = document.querySelectorAll('form.gesvalt-form');
        
        forms.forEach(form => {
            this.bindFormDynamicFields(form);
        });

        // Observer para formularios que se añadan dinámicamente
        this.observeNewForms();
    }

    bindFormDynamicFields(form) {
        if (form.dataset.gesvaltDynamicBound) return;
        
        form.dataset.gesvaltDynamicBound = 'true';

        console.log('Binding dynamic fields for form:', form);
        
        // Configurar cada dependencia
        Object.keys(this.fieldDependencies).forEach(dependentFieldName => {
            const config = this.fieldDependencies[dependentFieldName];
            const parentField = form.querySelector(`[name="${config.dependsOn}"]`);
            const dependentField = form.querySelector(`[name="${dependentFieldName}"]`);
            console.log('Parent field:', parentField, 'Dependent field:', dependentField);

            if (parentField && dependentField) {
                this.setupFieldDependency(parentField, dependentField, config);
            }
        });
    }

    setupFieldDependency(parentField, dependentField, config) {
        console.log('Setting up dependency:', parentField.name, '->', dependentField.name);
        
        // Configurar el evento de cambio en el campo padre
        parentField.addEventListener('change', () => {
            this.updateDependentField(parentField, dependentField, config);
        });
        
        // Ejecutar la actualización inicial
        this.updateDependentField(parentField, dependentField, config);
    }

    updateDependentField(parentField, dependentField, config) {
        const parentValue = parentField.value;
        const newOptions = config.options[parentValue] || [];
        
        console.log('Updating dependent field:', dependentField.name, 'based on parent value:', parentValue);
        console.log('New options:', newOptions);
        
        // Limpiar opciones actuales (excepto la primera que suele ser placeholder)
        this.clearSelectOptions(dependentField);
        
        // Añadir nueva opción placeholder si no existe
        if (dependentField.options.length === 0) {
            const placeholderOption = document.createElement('option');
            placeholderOption.value = '';
            placeholderOption.textContent = (window.GesvaltFormulariosConf && window.GesvaltFormulariosConf.i18n && window.GesvaltFormulariosConf.i18n.select_option) 
                ? window.GesvaltFormulariosConf.i18n.select_option 
                : 'Selecciona una opción';
            placeholderOption.disabled = true;
            placeholderOption.selected = true;
            dependentField.appendChild(placeholderOption);
        }
        
        // Añadir las nuevas opciones
        newOptions.forEach(option => {
            const optionElement = document.createElement('option');
            optionElement.value = option.value;
            optionElement.textContent = option.text;
            dependentField.appendChild(optionElement);
        });
        
        // Resetear el valor del campo dependiente
        dependentField.value = '';
        
        // Mostrar/ocultar el campo dependiente según si hay opciones
        this.toggleFieldVisibility(dependentField, newOptions.length > 0);
        
        // Disparar evento personalizado para notificar el cambio
        dependentField.dispatchEvent(new CustomEvent('gesvalt:field-updated', {
            detail: {
                parentField: parentField.name,
                parentValue: parentValue,
                newOptions: newOptions
            }
        }));
    }

    clearSelectOptions(selectField) {
        // Mantener solo la primera opción si es un placeholder
        const firstOption = selectField.options[0];
        const isPlaceholder = firstOption && (firstOption.disabled || firstOption.value === '');
        
        // Limpiar todas las opciones
        selectField.innerHTML = '';
        
        // Restaurar placeholder si existía
        if (isPlaceholder) {
            selectField.appendChild(firstOption);
        }
    }

    toggleFieldVisibility(field, visible) {
        const fieldContainer = this.getFieldContainer(field);
        
        if (fieldContainer) {
            if (visible) {
                fieldContainer.style.display = '';
                fieldContainer.classList.remove('gesvalt-field-hidden');
            } else {
                fieldContainer.style.display = 'none';
                fieldContainer.classList.add('gesvalt-field-hidden');
            }
        }
    }

    getFieldContainer(field) {
        // Buscar el contenedor del campo (puede variar según el HTML)
        let container = field.closest('.gesvalt-field');
        if (!container) {
            container = field.closest('.form-group');
        }
        if (!container) {
            container = field.closest('div');
        }
        return container;
    }

    observeNewForms() {
        // Observer para detectar formularios añadidos dinámicamente
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        // Buscar formularios en el nodo añadido
                        const forms = node.matches && node.matches('form.gesvalt-form') 
                            ? [node] 
                            : node.querySelectorAll && node.querySelectorAll('form.gesvalt-form') || [];
                        
                        forms.forEach(form => {
                            this.bindFormDynamicFields(form);
                        });
                    }
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    // Método público para añadir nuevas dependencias dinámicamente
    addFieldDependency(dependentFieldName, config) {
        this.fieldDependencies[dependentFieldName] = config;
        
        // Re-bind todos los formularios existentes
        const forms = document.querySelectorAll('form.gesvalt-form');
        forms.forEach(form => {
            const parentField = form.querySelector(`[name="${config.dependsOn}"]`);
            const dependentField = form.querySelector(`[name="${dependentFieldName}"]`);
            
            if (parentField && dependentField) {
                this.setupFieldDependency(parentField, dependentField, config);
            }
        });
    }

    // Método público para obtener las opciones actuales de un campo
    getFieldOptions(fieldName, parentValue) {
        const config = this.fieldDependencies[fieldName];
        if (!config) return [];
        
        return config.options[parentValue] || [];
    }
}

document.addEventListener('DOMContentLoaded', () => {

    // Crear instancia global
    const gesvaltDynamicFields = new GesvaltDynamicFields();
    
    // Exponer API pública
    window.GesvaltDynamicFields = GesvaltDynamicFields;
    window.gesvaltDynamicFields = gesvaltDynamicFields;
    
    // Exponer para uso en otros módulos
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = gesvaltDynamicFields;
    }
    
    console.log('Gesvalt Dynamic Fields module loaded');

});